module.exports = __webpack_public_path__ + "static/media/first.1eac1a65.svg";